export const preLayoutSettingConfigMap = {
  // knife: '刀直径设置',
  diameter: '刀直径',
  // holeFaceSetting: '孔槽集中面设置',
  holeConcentrated: '孔集中面',
  prorate_holes_slots_of_both_side: '按比例分配正反面孔槽',
  apertureSlotConcentrated: '槽集中面',
  // processChainAndHoleOnBigPlaneBack:
  //   '拉直器、孔槽加工设置-拉直器和铰链杯孔放到大板反面加工',
  custom_special_hole_slot_side: '特殊孔槽规则加工面',
  curveSecondCutEnable: '异形板二次切割',
  desMaterialSwitch: '指定材质',
  throughHoleSlotSameSide:
    '拉直器、孔槽加工设置-打穿孔槽所在面跟随该小板上未穿孔槽',
  hs_on_front_aft_shunt: '孔槽分流中设置的特殊孔槽优先排在大板正面功能', // 孔槽分流中设置的特殊孔槽优先排在大板正面功能
  cal_turn_num_aft_shunt:
    '启用孔槽分流后按照实际在雕刻机加工的反面孔槽计算翻板次数', // 在孔槽分流后计算翻板次数
  percentage_of_back_hole_slot: '反面孔槽占比',
  // highgloss_setting: '高光板设置',
  highgloss_direction: '高光板排版方向',
  auto_high_gloss_reverse: '仅带有反面孔槽的大板自动翻面',
  high_gloss_plank_no_rotate: '高光板不转板',
  // edgePlankSlotDirection: '靠边板槽设置',
  sideBoardPlacing: '靠边板槽方向',
  // countertopSetting: '台面设置',
  xyReverse: 'XY轴互换',
  startPosition: '工位起始点',
  counter_limit_able: '台面宽度限制开关',
  counter_width: '台面宽度',
  // longPlankCuttingSetting: '长板加工设置',
  longPlankCuttingEnable: '长板加工',
  vacuumPumpPauseWay: '真空关闭方式',
  longPlankShortExpandedSize: '短边放量',
  longPlankExpandedSize: '长边放量',
  longPlankMinLength: '长板分两次切割条件-长边超过',
  longPlankShortMinLength: '长板分两次切割条件-短边超过',
  generalPlankThick: '二次切割对象-非门板厚度≥',
  single_door_thick: '二次切割对象-门板厚度≥',
  cutSingleDoor: '二次切割对象-门板',
  cutGeneralPlank: '二次切割对象-常规板',
  specified_board_secondary_cutting: '指定板件名切割',
  force_board_name: '指定板名强制启用',
  secondary_cutting_board_list: '指定板件名切割板件名列表',
  // surplusSetting: '余料摆放位置设置',
  surplusPosition: '余料摆放位置',
  // decimalSetting: '小数保留位数设置',
  decimal: '小数保留位数',
  // boardGapsSetting: '排版间隙设置',
  boardGap: '排版间隙',
  // barCodeSetting: '板件条码设置',
  uniqueBarCode: '板件条码唯一',
  genSimpleLabelBarcode: '生成简易条码',
  throughTowSideToCut: '通孔加工方式',
  through_slot_two_side_cut: '通槽加工方式',
  mentaoji_enable: '启用锯切雕刻机',
  processType: '加工工艺',
  sawToLayout: '启用锯片厚度排版',
  horizontalWidth: '锯片横切刀直径',
  edgeNoSaw: '启用已封好不再切的大板边',
  edgeNoSawSide: '已封好不再切的大板边值',
  trimmingSetting: '修边设置',
  sameWidthPlank: '每张大板上只排相同宽度小板',
  noCutEmptyPath: '切割时不生成空走路径',
  sawCutOnlyWeld: '焊接板才使用锯片加工',
  sortByHeight: '按板件长度依次排版',
}

const switchObj = {
  true: '开启',
  false: '关闭',
}

export const preLayoutSettingConfigValues = {
  holeConcentrated: {
    front: '正面',
    back: '反面',
  },
  apertureSlotConcentrated: {
    front: '正面',
    back: '反面',
  },
  sideBoardPlacing: {
    default: '系统默认',
    inside: '大板内侧',
    outside: '大板外侧',
  },
  longPlankCuttingEnable: switchObj,
  vacuumPumpPauseWay: {
    after_one_plank: '单块长板切割后',
    after_all_plank: '整张大板切割后',
  },
  cutSingleDoor: switchObj,
  cutGeneralPlank: switchObj,
  specified_board_secondary_cutting: switchObj,
  force_board_name: switchObj,
  surplusPosition: {
    topLeft: '左上角',
    topRight: '右上角',
    bottomLeft: '左下角',
    bottomRight: '右下角',
  },
  trimSide: {
    topLeft: '左边、上边',
    topRight: '右边、上边',
    bottomLeft: '左边、下边',
    bottomRight: '右边、下边',
  },
  uniqueBarCode: switchObj,
  genSimpleLabelBarcode: switchObj,
  counter_limit_able: switchObj,
  prorate_holes_slots_of_both_side: switchObj,
  hs_on_front_aft_shunt: switchObj, // 孔槽分流中设置的特殊孔槽优先排在大板正面功能
  cal_turn_num_aft_shunt: switchObj, // 在孔槽分流后计算翻版次数
  throughTowSideToCut: {
    true: '分两次打穿',
    false: '一次打穿',
  },
  through_slot_two_side_cut: {
    true: '分两次打穿',
    false: '一次打穿',
  },
  mentaoji_enable: switchObj,
  processType: {
    weldingPlank: '焊接板',
    doorFrame: '门套',
  },
  sawToLayout: switchObj,
  edgeNoSaw: switchObj,
  edgeNoSawSide: {
    top: '上边',
    bottom: '下边',
    left: '左边',
    right: '右边',
  },
  sortByHeight: {
    top: '小板在上',
    bottom: '小板在下',
  },
}

export const preLayoutSettingConfigCompareList = [
  {
    title: '开料刀直径',
    keys: ['diameter'],
  },
  {
    title: '孔槽集中面',
    keys: [
      'holeConcentrated',
      'prorate_holes_slots_of_both_side',
      'apertureSlotConcentrated',
      // 'processChainAndHoleOnBigPlaneBack',
      'throughHoleSlotSameSide',
      'percentage_of_back_hole_slot',
      'hs_on_front_aft_shunt', // 孔槽分流中设置的特殊孔槽优先排在大板正面功能
      'cal_turn_num_aft_shunt', // 在孔槽分流后计算翻版次数
    ],
  },
  {
    title: '高光板设置',
    keys: [
      'highgloss_direction',
      'auto_high_gloss_reverse',
      'high_gloss_plank_no_rotate',
    ],
  },
  {
    title: '靠边板槽放置',
    keys: ['sideBoardPlacing'],
  },
  {
    title: '台面设置',
    keys: [
      'xyReverse',
      'startPosition',
      'counter_limit_able',
      'counter_width',
    ],
  },
  {
    title: '长板加工',
    keys: [
      'longPlankCuttingEnable',
      'vacuumPumpPauseWay',
      'longPlankShortExpandedSize',
      'longPlankExpandedSize',
      'longPlankMinLength',
      'longPlankShortMinLength',
      'generalPlankThick',
      'single_door_thick',
      'cutSingleDoor',
      'cutGeneralPlank',
      'specified_board_secondary_cutting',
      'force_board_name',
      'secondary_cutting_board_list',
      'curveSecondCutEnable',
      'desMaterialSwitch',
    ],
  },
  {
    title: '余料设置',
    keys: ['surplusPosition'],
  },
  {
    title: '修边设置',
    keys: ['trimSide'],
  },
  {
    title: '小数保留位数',
    keys: ['decimal'],
  },
  {
    title: '排版间隙设置',
    keys: ['boardGap'],
  },
  {
    title: '板件条码设置',
    keys: ['uniqueBarCode', 'genSimpleLabelBarcode'],
  },
  {
    title: '切割打孔方式',
    keys: ['throughTowSideToCut', 'through_slot_two_side_cut'],
  },
  {
    title: '防跑板设置',
    keys: ['scattered_layout', 'safe_length'],
  },
  {
    title: '锯切雕刻机设置',
    keys: [
      'mentaoji_enable',
      'processType',
      'sawToLayout',
      'horizontalWidth',
      'edgeNoSaw',
      'edgeNoSawSide',
      'sameWidthPlank',
      'noCutEmptyPath',
      'sawCutOnlyWeld',
    ],
  },
]
